import store from "@/redux/store";
import { v4 as uuid } from "uuid";
import WPAPI from "@/api/WPAPI";
import { createSlice, current, nanoid, createAsyncThunk } from '@reduxjs/toolkit'
import {ROLES, WP} from "@/actions/globalConst";
import { CompanyModel } from "@/models/Company";
import { RolesModel } from "@/models/Roles";
import rootReducer from "reducers";

export const initialState = {
    items: null,
    sectors: null,
    departments: null,
    selected: false,
    childs: false,
    filter: false,
    tenants: false,
    view: ROLES.VIEW_OVERVIEW,
    apiState: ROLES.API_INIT,
    key: "",
    error: null,
    pos: {x:0, y:0},
    co: 0,
    importStates: {}
};
let task = null;

const rejectEventHandler=((state, action) => {
    state.error = action.payload;
    state.key = uuid().slice(0, 8);
});
const pendingEventHandler=((state, action) => {
    state.apiState = WP.API_PROCESSING;
})
let fullFilledEventHandler= ( (state, action) => {
    if(action.payload.data.items) {
        state.items = action.payload.data.items;
    }
    if(action.payload.data.sectors) {
        state.sectors = action.payload.data.sectors;
    }
    if(action.payload.data.departments) {
        state.departments = action.payload.data.departments;
    }
    if(action.payload.data?.process) {
        state.selected = action.payload.data?.process;
//        state.selected = {...action.payload.data?.process};
    }
    if(action.payload.data?.tenants) {
        state.tenants = action.payload.data?.tenants;
//        state.selected = {...action.payload.data?.process};
    }
    if(action.payload.data?.filter) {
        state.filter = action.payload.data?.filter;
//        state.selected = {...action.payload.data?.process};
    }

    if(action.payload.data?.imports) {
        state.importStates = action.payload.data?.imports;
    }

    if(action.payload.data?.importObj) {
        let importObj = action.payload.data?.importObj;

        state.importStates = { ...state.importStates, [importObj.id]: importObj }
        
//        state.selected = {...action.payload.data?.process};
    }
    
    
    state.apiState = WP.API_READY;
    state.key = uuid().slice(0, 8);
    state.error = null;
    return state;
});

const WorkProcessReducer = createSlice({
  name: 'workProcess',
  initialState,
  reducers: {
      testme(state, action) {
          state.co += 1;
      }
    // omit existing reducers here
  },
  extraReducers(builder) {
    task = getWorkProcesses;
    builder.addCase(task.fulfilled, (state, action) => fullFilledEventHandler(state, action)).addCase(task.rejected, (state, action) => rejectEventHandler(state, action)).addCase(task.pending, (state, action) => pendingEventHandler(state, action));

    task = wp;
    builder.addCase(task.fulfilled, (state, action) => fullFilledEventHandler(state, action)).addCase(task.rejected, (state, action) => rejectEventHandler(state, action)).addCase(task.pending, (state, action) => pendingEventHandler(state, action));

    task = copyWP;
    builder.addCase(task.fulfilled, (state, action) => fullFilledEventHandler(state, action)).addCase(task.rejected, (state, action) => rejectEventHandler(state, action)).addCase(task.pending, (state, action) => pendingEventHandler(state, action));

      
    task = wpUpdate;
    builder.addCase(task.fulfilled, (state, action) => fullFilledEventHandler(state, action)).addCase(task.rejected, (state, action) => rejectEventHandler(state, action)).addCase(task.pending, (state, action) => pendingEventHandler(state, action));
      

    builder.addMatcher(
      (action) => action.type.endsWith('/receiveMessage'),
      (state, action) => {
          let item = JSON.parse(action.payload.event.data);
            if(item.type == "TEST") {
                state.pos = item.payload;
                let vh = document.documentElement.scrollHeight
                let vw = document.documentElement.offsetWidth
                state.pos.y = (vh / item.payload.scrollHeight ) * item.payload.y + item.payload.scrollTop;
                state.pos.x = (vw /item.payload.vw ) * item.payload.x;
            }
       });

    builder.addMatcher(
      (action) => action.type.endsWith('/TEST'),
      (state, action) => {
          let item = JSON.parse(action.payload.event.data);
            if(item.type == "TEST") {
                state.pos = item.payload;
                let vh = document.documentElement.offsetHeight
                let vw = document.documentElement.offsetWidth
                state.pos.y = (vh / item.payload.vh ) * item.payload.y;
                state.pos.x = (vw /item.payload.vw ) * item.payload.x;
            }
       });

    builder.addMatcher(
      (action) => action.type == "switchtenant/pending",
      (state, action) => {
        state.selected = false;
        state.childs = false;
        state.items = null;
        state.view = ROLES.VIEW_OVERVIEW;
        state.apiState = ROLES.API_INIT;
          
       })

       builder.addMatcher(
         (action) => action.type == "chat/receiveMessage" && action.event ,
         (state, action) => {
              let data = null;
              if(action.event && action.event.type == "workprocesses") {
                if(state.selected.id == action.event.dataObj.parentid) {
                    state.selected.child_processes = action.event.dataObj.children;
                    let currentItem = {...current(state.selected)};    
                }
                
              }
        })
       
           
  }
  })

export const copyWP = createAsyncThunk(WP.API_COPY_WP, async (data, event) => {
    let response = null;
    try {
          response = await WPAPI.copyWorkprocesses(data);
    } catch (err) {
      return event.rejectWithValue({status: err.response.status, statusText: err.response.statusText, data: err.response.data})
    }
    return response.data;
  }
)


export const getWorkProcesses = createAsyncThunk(WP.API_LOAD_ITEMS, async (data: Object = null, event) => {
    let response = null;
    try {
          response = await WPAPI.getWorkprocesses(data);
    } catch (err) {
      return event.rejectWithValue({status: err.response.status, statusText: err.response.statusText, data: err.response.data})
    }
    return response.data;
  }
)

  
export const wp = createAsyncThunk(WP.API_INIT, async (data: object = null, event) => {
    let response = null;
    try {
          response = await WPAPI.getById(data);
    } catch (err) {
      return event.rejectWithValue({status: err.response.status, statusText: err.response.statusText, data: err.response.data})
    }
    return response.data;
  }
)

export const getBaseInfo = createAsyncThunk('baseinfo', async (data: object = null, event) => {
    let response = null;
    try {
          response = await WPAPI.getBaseInfo(data);
    } catch (err) {
      return event.rejectWithValue({status: err.response.status, statusText: err.response.statusText, data: err.response.data})
    }
    return response.data;
  }
)

export const wpUpdate = createAsyncThunk(WP.ACTION_STORE, async (data, event) => {
    let response = null;
    try {
          response = await WPAPI.update(data);
    } catch (err) {
      return event.rejectWithValue({status: err.response.status, statusText: err.response.statusText, data: err.response.data})
    }
    return response.data;
  }
)


export const { testme } = WorkProcessReducer.actions;
export default WorkProcessReducer.reducer